// Shared react-toastify options so every action file pops toasts with the
// same timing/behavior.
const toastOptions = {
  autoClose: 8000,
  draggable: true,
};

export default toastOptions;
